/**
 * channelsGuide.tsx
 */
import DateUtils from '@shared/utils/date';
import Rail from '@shared/classes/rail';
import MainTemplate from '@components/templates/main/ui/main';
import useEpgByDays from '@shared/components/utils/hooks/useEpgByDays';
import { selectCurrentParams } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useEffect, useState } from 'react';
import {
  RailDisplayMode,
  RailOrderSort,
  RailOrderType,
} from '@shared/types/enums/rail';

/**
 * Displays the channel guide page with the rails.
 */
export default function ChannelGuide() {
  // Selectors
  const currentParams = useAppSelector(selectCurrentParams);

  // State
  const [rails, setRails] = useState<Rail[]>(
    (currentParams?.rails as Rail[]) || []
  );

  // GraphQL hook
  const { complete, epg, onPagination } = useEpgByDays({
    channelId: (currentParams?.channelId as string) || '',
  });

  useEffect(() => {
    const newRails: Rail[] = [];
    for (const [key, events] of Object.entries(epg)) {
      const rail = Rail.constructorWithData(
        {
          staticRail: true,
          section: {
            title: DateUtils.getTime({
              customDate: key,
              displayDay: true,
              displayHours: false,
              displayMinutes: false,
              displaySeconds: false,
              displayDayOfWeek: true,
              displayToday: false,
              separator: ' ',
              utc: true,
            }),
            presentationType: RailDisplayMode.PHOTO,
            name: key,
          },
        },
        events
      );
      rail.sortRail(RailOrderType.DATE, RailOrderSort.ASCENDING);
      newRails.push(rail);
    }
    setRails(newRails);
  }, [epg]);

  return (
    <MainTemplate
      flags={{ complete }}
      rails={rails}
      onPagination={onPagination}
    />
  );
}
